import React from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import { PrintButton } from "../../components/printButton";
import { t } from "../../localization/localization";

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  maintainAspectRatio: false,
  plugins: {
    datalabels: {
      color: "white",
    },
  },
};

const generateLabels = (data) => {
  if (data.length === 0) return [];
  const startYear = data[0].year;
  const endYear = data[data.length - 1].year;
  const yearCount = endYear - startYear + 1;

  return new Array(yearCount).fill(0).map((e, i) => startYear + i);
};

const generateDatasets = (data) => {
  if (data.length === 0) return [];
  const quartiles = [1, 2, 3, 4];
  const quartileColors = ["#ADCB72", "#E6D46E", "#F2A460", "#CC6353"];
  const startYear = data[0].year;
  const endYear = data[data.length - 1].year;
  const yearCount = endYear - startYear + 1;

  const createDataset = (quartileNumber) =>
    new Array(yearCount)
      .fill(0)
      .map(
        (e, i) =>
          data.find(
            (element) =>
              element.year === startYear + i &&
              element.quartile === "Q" + quartileNumber
          )?.count ?? 0
      );

  return quartiles.map((quartileNumber, i) => ({
    label: "Q" + quartileNumber,
    data: createDataset(quartileNumber),
    backgroundColor: quartileColors[i],
  }));
};

export default class QDist extends React.Component {
  state = {
    data: [],
  };

  componentDidMount() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const crisId = urlSearchParams.get("crisId");
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/researcher/${crisId}/q-dist`)
      .then((res) => {
        this.setState({
          data: res.data.sort((e1, e2) => e1.year - e2.year),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";

    const labels = generateLabels(this.state.data);
    const datasets = generateDatasets(this.state.data);

    return (
      <div style={{ width: 440, height: 320, margin: "auto" }}>
        <PrintButton />
        <Bar
          data={{
            labels: labels,
            datasets: datasets,
          }}
          width={440}
          height={320}
          options={options}
        />
      </div>
    );
  }
}
